angular.module('trainerWebApp.services').factory('gridFormatters', ['$filter', 'mtypes', 'dateHelper', 'trainerPrivilege', '$window', function ($filter, mtypes, dateHelper, trainerPrivilege, $window) {
  var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);
  var mtypeLabels = {};

  mtypeLabels[mtypes.courseStateStatus.invited] = "Invited";
  mtypeLabels[mtypes.courseStateStatus.started] = "In progress";
  mtypeLabels[mtypes.courseStateStatus.completed] = "Completed";
  mtypeLabels[mtypes.courseStateStatus.unInvited] = "Uninvited";
  mtypeLabels[mtypes.courseStateStatus.missedCompletionDeadline] = "Missed deadline";
  mtypeLabels[mtypes.courseStatus.draft] = "Draft";
  mtypeLabels[mtypes.courseStatus.active] = "Active";
  mtypeLabels[mtypes.gradeStatus.failed] = "Failed";
  mtypeLabels[mtypes.gradeStatus.passed] = "Passed";
  mtypeLabels[mtypes.gradeStatus.notApplicable] = "NotApplicable";
  mtypeLabels[mtypes.userRole.administrator] = "Administrator";
  mtypeLabels[mtypes.userRole.trainer] = "Trainer";
  mtypeLabels[mtypes.userRole.trainee] = "Trainee";
  mtypeLabels[mtypes.userRole.manager] = "Manager";
  mtypeLabels[mtypes.userRole.teamLead] = "Team Lead";
  mtypeLabels[mtypes.userRole.reporter] = "Reporter";

  function mtypeFormatter(row, cell, value, columnDef, item) {
    var suffix = '';
    if (value == mtypes.courseStateStatus.invited && item.addedAfterCompletion)
      suffix = ' (after completion)';
    return mtypeLabels[value] + suffix;
  }

  function dateFormatterBasic(value) {
    return $filter('date')(value, 'dd-MMM-yyyy');
  }

  function dateFormatter(row, cell, value, columnDef, item) {
    return dateFormatterBasic(value);
  }

  function datetimeFormatter(row, cell, value, columnDef, item) {
    return $filter('date')(value, 'dd-MMM-yyyy h:mm a');
  }

  function checkLockedCourseStatus(statusDate, gradeStatus, courseStateStatus) {
    return !statusDate && !gradeStatus && courseStateStatus == mtypes.courseStateStatus.completed;
  }

  function inviteFormatter(row, cell, value, columnDef, item) {
    if (item.metaType.indexOf('courseRow') > -1) {
      var linkClass = '';
      var liveCourseLinkClass = item.status.courseStateStatus == mtypes.courseStateStatus.completed ? 'action-set-score' : 'action-complete';
      var liveCourseLinkText = item.status.courseStateStatus == mtypes.courseStateStatus.completed ? 'Set Score' : 'Complete';
      var title = '';

      if (item.removed) {
        linkClass = 'disabled';
        title = 'Removed from series';
      }
      if (item.courseType != mtypes.courseType.live && item.failEnforcedNoRetake) {
        linkClass = 'disabled';
        title = 'Reset failed course first';
      }
      if (!item.canResetTrainees || checkLockedCourseStatus(item.statusDate, item.status.gradeStatus, item.email)) {
        linkClass = 'disabled';
      }

      var html = '';
      if (item.failEnforcedNoRetake)
        html = html + '<a ng-href class=" ' + linkClass + '" title="' + title + '">Reset</a>';

      if (!item.failEnforcedNoRetake)
        html = html + '<a ng-href class="action-retake ' + linkClass + '" title="' + title + '">Reset</a>';

      if (item._parent.status != mtypes.courseStateStatus.completed &&
        ((item.canMarkTraineeCompleted && item.courseType == mtypes.courseType.live &&
        item.status.courseStateStatus != mtypes.courseStateStatus.completed) ||
        (item.canSetTraineeScore && item.courseType == mtypes.courseType.live &&
        item.status.courseStateStatus == mtypes.courseStateStatus.completed && item.hadQuiz))) {
        liveCourseLinkClass = liveCourseLinkClass + ' ' + linkClass;
        if (item.canResetTrainees)
          liveCourseLinkClass = liveCourseLinkClass + ' action-spacer';

        html = html + '<a ng-href class="' + liveCourseLinkClass + '" title="' + title + '">' + liveCourseLinkText + '</a>';
      }
      return html;
    }
    return dateFormatter(row, cell, value, columnDef, item);
  }

  function stringToDate(value) {
    var d = new Date(Date.parse(value));
    return dateFormatterBasic(d);
  }

  function deadlineFormatter(row, cell, value, columnDef, item) {
    var userRole = trainerPrivilege.roles();
    if (item.metaType.indexOf('courseRow') > -1)
      return ''; //don't show on courses
    if (item.metaType.indexOf('courseHeaderRow') > -1)
      return ''; //don't show on course headers

    if (item.completionDeadline) {
      if (item.status == mtypes.courseStateStatus.completed || !userRole.canExtendTraineeDeadlines)
        return stringToDate(item.completionDeadline);
      return stringToDate(item.completionDeadline) +
        '<a value="' + item.completionDeadline +
        '" class="action-extendDeadline datepicker icon-calendar">' +
        '</a>';
    } else if (columnDef.hasDeadline) {
      if (item.traineeIsInCourseInSeries) {
        if (item.seriesId) {
          if (userRole.canExtendTraineeDeadlines)
            return '<a class="action-manageUser">Set in series</a>';
          return '<a class="action-manageUser">See in series</a>';
        }
        return 'Course in multiple series';
      }

      if (item.status == mtypes.courseStateStatus.completed || !userRole.canExtendTraineeDeadlines)
        return '';
      return '<a class="action-extendDeadline datepicker">Set</a>';
    } else {
      return '';
    }
  }

  function courseStateStatusFormatter(row, cell, value, columnDef, item) {
    if (checkLockedCourseStatus(item.statusDate, item.status.gradeStatus,  item.email))
      return "<em>Locked</em>";

    return value !== mtypes.courseStateStatus.completed ?
      mtypeFormatter(row, cell, value, columnDef, item) :
    mtypeFormatter(row, cell, value, columnDef, item) + ' ' + datetimeFormatter(row, cell, item.statusDate, columnDef, item);
  }

  function traineeNameFormatter(row, cell, value, columnDef, item) {
    var userRole = trainerPrivilege.roles();
    if (item.metaType) return _.escape(value);

    var reinviteButtonClass = "btn btn-mini btn-info action action-reinvite";
    var remindButtonClass = "btn btn-mini btn-info action action-remind";
    var dropButtonClass = "btn btn-mini btn-info action action-delete";
    var updateButtonClass = "btn btn-mini btn-info action action-update";
    var completeButtonClass = "btn btn-mini btn-info action action-complete";
    var remindText = "Remind";
    var reinviteText = "Reset";
    var completeText = "Complete";
    var updateText = "Update";
    var remindDisabled = '';
    var dropDisabled = '';
    var completeDisabled = '';
    var reinviteDisabled = '';
    var updateDisabled = '';

    if (!item.canBeReinvited) {
      reinviteDisabled += ' disabled';
    }

    if ((item.status == mtypes.courseStateStatus.completed && item.courseType != mtypes.courseType.live) || item.courseCount == 0) {
      dropButtonClass += " disabled";
      remindButtonClass += " disabled";
      remindDisabled = " disabled";
      dropDisabled = " disabled";
    } else if (!item.pokeRemindEnabled) {
      remindButtonClass += " disabled";
      remindText = "Reminded";
      remindDisabled = " disabled";
    }

    if (!item.canBeDropped && !dropDisabled)
      dropDisabled = " disabled";

    if (!item.canUpdateSeries)
      updateDisabled = " disabled";

    if (!item.canBeCompleted || item.traineeIsInCourseInSeries)
      completeDisabled = " disabled";

    if (!userRole.canDropTrainees)
      dropButtonClass += " hide";

    if (!userRole.canRemindTrainees || item.courseType == mtypes.courseType.live)
      remindButtonClass += " hide";

    if (!userRole.canResetTrainees)
      reinviteButtonClass += " hide";

    if (item.courseType != mtypes.courseType.live || !userRole.canMarkTraineeCompleted)
      completeButtonClass += " hide";

    if (!userRole.canUpdateTraineesInSeries || !item.hasUsersWhoCanBeUpdated)
      updateButtonClass += " hide";

    var tempResult = '<div class="action-button-group"><button' + dropDisabled + ' class="' + dropButtonClass + '">Drop</button>' +
      '<button' + reinviteDisabled + ' class="' + reinviteButtonClass + '">' + reinviteText + '</button>' +
      '<button ' + completeDisabled + ' class="' + completeButtonClass + '">' + completeText + '</button>' +
      '<button' + updateDisabled + ' class="' + updateButtonClass + '">' + updateText + '</button>' +
      '<button' + remindDisabled + ' class="' + remindButtonClass + '">' + remindText + '</button></div>';

    return '<span></span><div>' + _.escape(value) + '</div>' + tempResult;
  }

  function traineeEmailFormatter(row, cell, value, columnDef, item) {
    if (!item.metaType) item.metaType = '';
    return item.metaType.indexOf('courseRow') > -1 ? courseStateStatusFormatter(row, cell, value, columnDef, item) : value;
  }

  function traineeEmailWithInviteFormatter(row, cell, value, columnDef, item) {
    if (!value) {
      return "";
    }
    var email = '<div class="inline-email tooltiped showWhenEllipsis" title="' + value + '">' + value + '</div>';
    return '<span class="email-cell-wrapper">' + email + '</span>';
  }

  function traineeImageFormatter(row, cell, value, columnDef, item) {
    return '<img src = "' + value + '"/>';
  }

  function checkboxFormatter(row, cell, value, columnDef, item) {
    var checked = item.selected || false;
    return checked ? '<input type="checkbox" checked>' : '<input type="checkbox">';
  }

  function checkboxInviteFormatter(row, cell, value, columnDef, item) {
    var checked = item.selected || false;
    var disabled = ~[mtypes.courseStateStatus.invited, mtypes.courseStateStatus.started, mtypes.courseStateStatus.completed].indexOf(item.status);

    var result = '<input type="checkbox" ';
    result += checked ? ' checked' : '';
    result += disabled ? 'disabled' : '';
    return result + '>';
  }

  function courseRequiredFormatter(row, cell, value, columnDef, item) {
    var userRole = trainerPrivilege.roles();
    var required = item.required ? 'Yes' : 'No';
    var disabled = ~[mtypes.courseStateStatus.completed, mtypes.courseStateStatus.missedCompletionDeadline].indexOf(item.status)
      || item.traineeIsInCourseInSeries || !userRole.canResetTrainees;
    var cssClass = disabled ? 'action-required' : 'action-required enabled';
    return '<span class="' + cssClass + '">' + required + '</span>';
  }

  function groupNameFormatter(row, cell, value, columnDef, item) {
    var traineesInGroup = item.traineeIds ? item.traineeIds.length : item.trainees.length;

    var groupName = '<div class="inline-group-name">' + _.escape(value) + '</div>';
    var cnt = ' <div class="inline-count">(' + traineesInGroup + ')</div>';

    return '<div class="group-name-cell-wrapper">' + groupName + cnt + '</div>';
  }

  function yammerGroupNameFormatter(row, cell, value, columnDef, item) {
    var groupMembers = item.members ? item.members : 0;

    var groupName = '<div class="inline-group-name">' + value + '</div>';
    var cnt = ' <div class="inline-count">(' + groupMembers + ')</div>';

    return '<div class="group-name-cell-wrapper">' + groupName + cnt + '</div>';
  }

  function showCertificateOrCheckmark(certLink, grade, gradeStatus, hasQuizzes) {
    if (gradeStatus == mtypes.gradeStatus.none && !grade) return;
    var passed = gradeStatus == mtypes.gradeStatus.passed || gradeStatus == mtypes.gradeStatus.notApplicable;
    var certLinkValue = certLink ? '<a href=\"' + certLink + '\" target="_blank" class="action-certificate" title="View Certificate"></a>' : '';

    if (hasQuizzes || gradeStatus != mtypes.gradeStatus.notApplicable) {
      var gradeCssClass = passed ? 'grade-passed' : 'grade-failed';
      var gradeValue = '<span class="' + gradeCssClass + '">' + grade + '%</span>';

      return '<span class="certficate-container">' + gradeValue + certLinkValue + '</span>';
    }
    else {
      return '<span class="action-passed-checkmark" title="Passed">' + certLinkValue + '</span>';
    }
  }

  function traineeSeriesStatusFormatter(row, cell, value, columnDef, item) {
    if (!item.metaType) item.metaType = '';
    if (item.metaType.indexOf('courseRow') > -1) {
      if(checkLockedCourseStatus(item.statusDate, item.status.gradeStatus,  item.email)) {
        return;
      }
      var hasQuizzes = value.hasQuizzes;
      if (item.courseType == mtypes.courseType.live)
        hasQuizzes = item.hadQuiz;
      return showCertificateOrCheckmark(value.cert, value.grade, value.gradeStatus, hasQuizzes);
    }
    if (item.metaType == 'courseHeaderRow')
      return value;

    //Send gradeStatus when series status value is completed
    if (hasNewSeriesFeature && value == mtypes.courseStateStatus.completed)
      value = item.gradeStatus == mtypes.gradeStatus.notApplicable ? mtypes.gradeStatus.passed : item.gradeStatus;

    var statusText = mtypeFormatter(row, cell, value, columnDef, item);
    if (item.status == mtypes.courseStateStatus.completed) {
      var certLinkValue = item.certificateUrl ? '<a href="' + item.certificateUrl + '" target="_blank" class="action-certificate" title="View Certificate"></a>' : '';

      //TODO: remove this when we move to new series
      var invitedAfterCompletionValue = '';
      if (item.invitedAfterCompletion)
        invitedAfterCompletionValue = '<i class="icon-exclamation-sign" title="Courses were added or removed from this series after the trainee completed the series. Series course data may be inconsistent. Completion date and scores are preserved." style="position:absolute; right:3px;"></i>';

      var contentModifiedAfterCompletionValue = '';
      if (item.contentModifiedAfterCompletion)
        contentModifiedAfterCompletionValue = '<i class="icon-exclamation-sign" title="The list of courses in this series was changed after this trainee had completed the series. Reporting data is based on the state of the series at the time of trainee completion." style="position:absolute; right:3px;"></i>';

      statusText = '<div class="pull-right" style="width:30px;">' + certLinkValue + invitedAfterCompletionValue + contentModifiedAfterCompletionValue + '</div>' + statusText;

      if (item.seriesHasQuizzes || (hasNewSeriesFeature && item.grade !== null)) {
        var gradeCssClass = item.passed ? 'grade-passed' : 'grade-failed';
        var grade = item.grade != null ? ' (' + item.grade + '%)' : '';
        statusText += '<span class="' + gradeCssClass + '">' + grade + '</span>';
      }
      else if (item.passed) {
        statusText += '<span class="action-passed-checkmark" title="Passed">' + '</span>';
      }

      statusText += '</span>';
    }

    return statusText;
  }

  function traineeCourseStatusFormatter(row, cell, value, columnDef, item) {
    var userRole = trainerPrivilege.roles();

    if (!item.metaType) item.metaType = '';
    if (item.metaType.indexOf('courseRow') > -1) {
      return showCertificateOrCheckmark(value.cert, value.grade, value.gradeStatus, item.hasQuizzes);
    }
    var result = '';
    if (item.status == mtypes.courseStateStatus.completed) {
      var certLinkValue;
      if (item.courseType == mtypes.courseType.live && userRole.canSetTraineeScore && item.hadQuiz && !item.traineeIsInCourseInSeries)
        certLinkValue = item.certificateUrl ? '<a href=\"' + item.certificateUrl + '\" target="_blank" class="action-certificate certificate-with-score" title="View Certificate"></a>' : '';
      else
        certLinkValue = item.certificateUrl ? '<a href=\"' + item.certificateUrl + '\" target="_blank" class="action-certificate" title="View Certificate"></a>' : '';

      if (!item.hasQuizzes && !item.hadQuiz && !item.finalGrade) {
        result += '<span class="action-passed-checkmark" title="Passed">' + certLinkValue + '</span>';
      } else if (item.courseType == mtypes.courseType.live && !item.grade && userRole.canSetTraineeScore && item.hadQuiz && !item.traineeIsInCourseInSeries) {
        result = result + '<a class="action-set-score">Set score</a>';
      } else {
        var gradeCssClass;
        var title;
        if (item.passed) {
          gradeCssClass = 'action-passed-checkmark grade-passed';
          title = 'Passed';
        } else {
          gradeCssClass = 'action-failed-checkmark grade-failed';
          title = 'Failed';
        }
        result += '<span title="' + title + '" class="' + gradeCssClass + '">';
        if ((item.courseType != mtypes.courseType.live || item.hadQuiz) && item.gradeStatus !== mtypes.gradeStatus.notApplicable)
          result += item.grade + '%';
        result += '</span>' + certLinkValue;

        if (item.courseType == mtypes.courseType.live && userRole.canSetTraineeScore && item.hadQuiz && !item.traineeIsInCourseInSeries)
          result += ' <a class="action-set-score">Set score</a>';
      }
    }
    else if (item.status == mtypes.courseStateStatus.started) {
      result += '<div class="trainee-in-progress-background" title="In Progress">' + item.progress + '%' + '</div>';
    }
    else if (item.status == mtypes.courseStateStatus.invited) {
      result += 'Invited';
    }
    else if (item.status == mtypes.courseStateStatus.missedCompletionDeadline) {
      result += 'Missed Deadline';
    }

    return result;
  }

  function permissionsFormatter(row, cell, value, columnDef, item) {
    if (mtypeLabels.hasOwnProperty(value))
      return mtypeLabels[value];
    return '';
  }

  return {
    dateFormatterBasic: dateFormatterBasic,
    mtypeFormatter: mtypeFormatter,
    dateFormatter: dateFormatter,
    courseStateStatusFormatter: courseStateStatusFormatter,
    traineeNameFormatter: traineeNameFormatter,
    traineeEmailFormatter: traineeEmailFormatter,
    traineeEmailWithInviteFormatter: traineeEmailWithInviteFormatter,
    traineeSeriesStatusFormatter: traineeSeriesStatusFormatter,
    traineeCourseStatusFormatter: traineeCourseStatusFormatter,
    groupNameFormatter: groupNameFormatter,
    yammerGroupNameFormatter: yammerGroupNameFormatter,
    inviteFormatter: inviteFormatter,
    deadlineFormatter: deadlineFormatter,
    permissionsFormatter: permissionsFormatter,
    mtypeLabels: mtypeLabels,
    checkboxFormatter: checkboxFormatter,
    checkboxInviteFormatter: checkboxInviteFormatter,
    courseRequiredFormatter: courseRequiredFormatter,
    traineeImageFormatter: traineeImageFormatter
  };
}]);
